import { render, staticRenderFns } from "./BaseInfoList.vue?vue&type=template&id=c1c55082&scoped=true&"
import script from "./BaseInfoList.vue?vue&type=script&lang=js&"
export * from "./BaseInfoList.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfoList.vue?vue&type=style&index=0&id=c1c55082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c55082",
  null
  
)

component.options.__file = "BaseInfoList.vue"
export default component.exports